import { useNavigate } from 'react-router-dom'
import { Alert, AlertTitle, Box, Typography } from "@mui/material"

export default function SubscriptionAlert() {
    const navigate = useNavigate()

    const styles = {
        alert: {
            p: '1rem 3rem',
            borderRadius: '32px',
            fontSize: '1rem',
            fontFamily: 'inherit',
            maxWidth: '500px',
            '& .MuiAlert-message': { width: '100%' }
        },
        alertTitle: { fontWeight: 700 },
        text: {
            fontSize: '90%',
            textWrap: 'balance',
            wordBreak: 'break-word',
            overflow: 'hidden'
        },
        span: {
            textDecoration: 'underline',
            cursor: 'pointer'
        }
    }

    return (
        <Box>
            <Alert severity="warning" color="error" sx={styles.alert}>
                <AlertTitle sx={styles.alertTitle}>Subscription Not Active</AlertTitle>
                <Typography component="p" variant="body1" sx={styles.text}>
                    Your subscription is not active. Please go to the 'Settings' tab and click
                    on 'Manage My Account' to update your subscription.{' '}
                    <span
                        style={styles.span}
                        onClick={() => navigate('/signup/choose-plan')}
                    >
                        You can also click this link.
                    </span>
                </Typography>
            </Alert>
        </Box>
    )
}
